import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import TermsAndConditions from "@/pages/TermsAndConditions";

export const Route = createFileRoute("/terms-and-conditions")({
  head: () => seoHead("/terms-and-conditions"),
  component: TermsAndConditions,
});
